import { render, staticRenderFns } from "./SidebarLevel1.vue?vue&type=template&id=3adca982"
import script from "./SidebarLevel1.vue?vue&type=script&lang=js"
export * from "./SidebarLevel1.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports